import GlossaryHeader from './GlossaryHeader';
export default GlossaryHeader;
